import Icon from '../components/Icon.vue'

Icon.register({"qrcode":{"width":448,"height":512,"paths":[{"d":"M0 224H192V32H0V224zM64 96H128V160H64V96zM256 32V224H448V32H256zM384 160H320V96H384V160zM0 480H192V288H0V480zM64 352H128V416H64V352zM416 288H448V416H352V384H320V480H256V288H352V320H416V288zM416 448H448V480H416V448zM352 448H384V480H352V448z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/qrcode.js
// module id = null
// module chunks = 